import analytics from '@xo-union/tk-analytics';
import type { EventData } from '@/app/interface/analytics.interface';
import {
  BUDGETER_INTERACTION,
  CLICK_THROUGH_VENDOR,
  ITEM_INTERACTION,
  NAVIGATE,
  ORGANIZER_BATCH_TASKS_UPDATE,
  ORGANIZER_PROMPT_DISPLAYED,
  QUESTION_ANSWERED,
  SEARCH_ORGANIZER,
  UPDATE_ORGANIZER_VIEW,
  VENDOR_MARKED_BOOKED,
  VENDOR_TILE_VIEWED,
  WEDDING_DETAILS_INTERACTION,
} from '@/app/analytics/constants';
import { getTimeZone } from './track.helper';

declare global {
  interface Window {
    analytics: {
      page: (...params: any[]) => void;
    };
  }
}

export const initAnalytics = () => {
  if (typeof window !== 'undefined') {
    window.analytics.page();
  }
};

export const trackEvent = (eventName: string, eventData: EventData) => {
  // Ensures this code runs client-side only.
  if (typeof window !== 'undefined') {
    analytics.track(eventName, {
      product: 'organizer',
      platform: 'web',
      ...eventData,
    });
  }
};

export const trackItemInteractionEvent = (eventData: EventData) => {
  trackEvent(ITEM_INTERACTION, eventData);
};
export const trackUpdateViewEvent = (eventData: EventData) => {
  trackEvent(UPDATE_ORGANIZER_VIEW, eventData);
};
export const trackNavigateOrganizerEvent = (eventData: EventData) => {
  trackEvent(NAVIGATE, eventData);
};
export const trackSearchOrganizerEvent = (eventData: EventData) => {
  trackEvent(SEARCH_ORGANIZER, eventData);
};
export const trackWeddingDetailsInteractionEvent = (eventData: EventData) => {
  trackEvent(WEDDING_DETAILS_INTERACTION, eventData);
};
export const trackQuestionAnsweredEvent = (eventData: EventData) => {
  trackEvent(QUESTION_ANSWERED, eventData);
};
export const trackOrganizerBatchUpdate = (eventData: EventData) => {
  trackEvent(ORGANIZER_BATCH_TASKS_UPDATE, eventData);
};
export const trackOrganizerPromptDisplayedEvent = (eventData: EventData) => {
  trackEvent(ORGANIZER_PROMPT_DISPLAYED, eventData);
};

export const trackVendorMarkedBooked = (eventData: EventData) => {
  trackEvent(VENDOR_MARKED_BOOKED, eventData);
};

export const trackBudgetInteractionEvent = (eventData: EventData) => {
  trackEvent(BUDGETER_INTERACTION, {
    budgeterVersion: '2024',
    timeZone: getTimeZone(),
    ...eventData,
  });
};
export const trackBudgeterVendorEvent = (
  event: string = CLICK_THROUGH_VENDOR,
  eventData: EventData
) => {
  trackEvent(event, {
    sourcePage: 'budgeter',
    budgeterVersion: '2024',
    ...eventData,
  });
};
export const trackBudgeterVendorImpression = (eventData: EventData) => {
  trackEvent(VENDOR_TILE_VIEWED, {
    product_listing_type: 'Rec Module: Budget Advisor Carousel',
    sort_type: 'recommended',
    ...eventData,
  });
};
export const trackChecklistVendorImpression = (eventData: EventData) => {
  trackEvent(VENDOR_TILE_VIEWED, {
    product_listing_type: 'Rec Module: Checklist Carousel',
    sort_type: 'recommended',
    ...eventData,
  });
};
export const trackCustomEvent = (event: string, eventData: EventData) => {
  trackEvent(event, {
    sourcePage: 'budgeter',
    budgeterVersion: '2024',
    timeZone: getTimeZone(),
    ...eventData,
  });
};
